import Container from "@mui/material/Container";

const StatsCourses = () => {

    return (
        <Container
            component="main"
            sx={{
                marginTop: 4,
                flexDirection: "column",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}>
            <h1>
                This is a Stats Course Page.
            </h1>
        </Container>
    )
}

export default StatsCourses;
